import { type SelectOptionType } from 'domains/merchandising/types/heroBanner.types'
import {
  PlacementTypeEnum,
  PlacementStatusEnum,
  PlacementDestinationTypeEnum,
  ButtonVariantEnum,
  PlacementPlatformEnum,
} from 'domains/merchandising/api'

export const dateFormat = 'MM/DD/YYYY'

export const bannerTypes = {
  text: PlacementTypeEnum.Text,
  image: PlacementTypeEnum.Image,
}

export const bannerDestinationTypes = {
  external: PlacementDestinationTypeEnum.External,
  department: PlacementDestinationTypeEnum.Department,
  collection: PlacementDestinationTypeEnum.Collection,
  product: PlacementDestinationTypeEnum.Product,
}

export const placementLocationOptions: SelectOptionType[] = [
  { value: PlacementPlatformEnum.Web, labelKey: 'merchandising.hero-banners.platform.web' },
  { value: PlacementPlatformEnum.Mobile, labelKey: 'merchandising.hero-banners.platform.mobile' },
  { value: PlacementPlatformEnum.Ios, labelKey: 'merchandising.hero-banners.platform.ios' },
  { value: PlacementPlatformEnum.Android, labelKey: 'merchandising.hero-banners.platform.android' },
]

export const placementDestinationOptions: SelectOptionType[] = [
  {
    value: '',
    labelKey:
      'merchandising.hero-banners.section.link-destination.input.destinationType.option.none',
  },
  {
    value: bannerDestinationTypes.external,
    labelKey:
      'merchandising.hero-banners.section.link-destination.input.destinationType.option.external',
  },
  // Note: temporarily hide department from UI until the SEO migrations are complete
  // {
  //   value: bannerDestinationTypes.department,
  //   labelKey:
  //     'merchandising.hero-banners.section.link-destination.input.destinationType.option.department',
  // },
  {
    value: bannerDestinationTypes.collection,
    labelKey:
      'merchandising.hero-banners.section.link-destination.input.destinationType.option.collection',
  },
  {
    value: bannerDestinationTypes.product,
    labelKey:
      'merchandising.hero-banners.section.link-destination.input.destinationType.option.product',
  },
]

export const ctaColorOptions: SelectOptionType[] = [
  {
    value: ButtonVariantEnum.Primary,
    labelKey: 'merchandising.hero-banners.section.content.select.primary',
  },
]

export const filterOptions: { [key: string]: SelectOptionType[] } = {
  type: [
    { value: bannerTypes.text, labelKey: 'merchandising.hero-banners.type.text' },
    { value: bannerTypes.image, labelKey: 'merchandising.hero-banners.type.image' },
  ],
  status: [
    { value: PlacementStatusEnum.Active, labelKey: 'merchandising.hero-banners.status.active' },
    { value: PlacementStatusEnum.Inactive, labelKey: 'merchandising.hero-banners.status.inactive' },
    { value: PlacementStatusEnum.Live, labelKey: 'merchandising.hero-banners.status.live' },
  ],
  platform: placementLocationOptions,
}
